/** Normalize immutable service identifiers to the shared server contract. */
export function normalizeServiceCode(value: string): string {
  return value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 64);
}

/** Validate a code that a carrier has manually overridden before creation. */
export function isServiceCode(value: string): boolean {
  return value.length > 0 && value.length <= 64 && /^[a-z0-9_]+$/.test(value);
}
